import { Box, Card, CardBody, CardHeader, Center, IconButton, Image } from "@chakra-ui/react"
import { faCheck } from "@fortawesome/free-solid-svg-icons"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { matchMediaIcon } from "@/functions/mediaFunctions"
import { MediaMeta, MediaType } from "@/pages/mediaManager"

export type SelectionMedia = MediaMeta & { selected: boolean }

const MediaSelectionCard: React.FC<{
	data: SelectionMedia,
	selected: boolean,
	onAdd: (id: string) => void,
	onRemove: (id: string) => void
}> = ({ data, selected, onAdd, onRemove}) => {
	return (
		<Card h={300} flex={1} flexDir='column' onClick={() => selected? onRemove(data.id) : onAdd(data.id)}>
			<CardHeader as='b' display='flex' gap={3} alignItems='center'>
				<FontAwesomeIcon icon={matchMediaIcon(data.type)} />
				{data.name}
				<Box flex={1} />
				<IconButton
					aria-label={selected ? 'Unselect' : "Select"}
					icon={selected ? <FontAwesomeIcon icon={faCheck} /> : <></>}
				/>
			</CardHeader>
			<CardBody flex={1} display='flex' justifyContent='center' alignItems='center' minH={0}>
				{data.type === MediaType.Audio || data.type === MediaType.Pdf ? (
					<Center flex={1} w='full'><FontAwesomeIcon icon={matchMediaIcon(data.type)} opacity={.5} size='5x' /></Center>
				) : (
					<Image src={data.iconUrl} fit='contain' w='full' h='100%' />
				)}
			</CardBody>
		</Card>
	)
}

export default MediaSelectionCard
